import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: '',
        userInfo: {},
        userId: '',
        menuList: [],
        buttonList: [],
        pagePermission: []
    },
    mutations: {
        SAVE_TOKEN(state, value) {
            state.token = value
            localStorage.setItem('Token', value);
        },
        SAVE_USER_ID(state, value) {
            state.userId = value
            localStorage.setItem('userId', value)
        },
        SET_MENU_LIST(state, value) {
            state.menuList = value;
        },
        SET_BUTTON_LIST(state, value) {
            state.buttonList = value;
        },
        SET_PAGE_PERMISSION (state, value) {
            console.log(value);
            state.pagePermission = value || [];
        },
        UPDATE_USERINFO(state, value) {
            state.userInfo = value || [];
        },
        
    },
    actions: {},
    modules: {}
})
